const format = require('./format')
const weeks = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
const dates = {
  today () {
    return format(Date.now(), 'YYYY-MM-DD')
  },
  toWeek (week) {
    if (!week || week < 1 || week > 7) {
      return ''
    }
    return weeks[week - 1]
  },
  format (date, fmt = 'YYYY-MM-DD HH:mm:ss') {
    return format(date, fmt)
  },
  formatUnix (time, fmt = 'YYYY-MM-DD HH:mm:ss') {
    if (!time) {
      return ''
    }
    return format(time * 1000, fmt)
  },
  durationUnix (duration) {
    if (!duration || duration < 0) {
      return ''
    }
    let day = Math.floor(duration / 60 / 60 / 24)
    let hour = Math.floor(duration / 60 / 60)
    let minute = Math.floor(duration / 60 % 60)
    let second = Math.floor(duration % 60)
    
    let human = ''
    if (day) {
      human += day + ' 天 '
    }
    if (hour) {
      human += hour + ' 时 '
    }
    if (minute) {
      human += minute + ' 分 '
    }
    if (second) {
      human += second + ' 秒 '
    }
    return human
  }
}

module.exports = dates



// WEBPACK FOOTER //
// ./src/tools/date/dates.js